import React from 'react';
import { Link } from "react-scroll";

export const NavItem = ({ iconCLass, link, children, onClick }) => {
    const handleClick = () => {
        window.gtag('event', 'click', {
            'event_category': 'Navigation',
            'event_label': children
        });
        if (onClick) onClick();
    };

    return (
        <li className="mb-2 last:mb-0">
            <Link
                activeClass="!bg-primary-600 !text-white !border-primary-400 !shadow-lg text-shadow-sm"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={100}
                onClick={handleClick}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-400 font-medium text-sm tracking-wide cursor-pointer transition-all duration-300 border border-transparent hover:bg-white/5 hover:text-white hover:border-white/10 hover:shadow-md hover:translate-x-1"
            >
                <i className={`${iconCLass} text-lg w-6 text-center transition-colors duration-300`}></i>
                <span className="font-sans">{children}</span>
            </Link>
        </li>
    );
};

export const Nav = ({ children }) => {
    return (
        <ul className="flex flex-col w-full">
            {children}
        </ul>
    );
};